import { message } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { convertServiceProviderListToDropdown } from "../../Helpers/ServiceProviderHelpers";
import ListDeviceMangement from "./ListDeviceMangement";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { apiCallback } from "../../ApiHandlers/Common";
import MainPage from "../MainPage";
import { NavMenuItems } from "../../Constants/Constants";

class DeviceManagement extends Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.deviceManagement.icon()}
        <span>{NavMenuItems.deviceManagement.label}</span>
      </>,
    ];
    this.state = {
      providerdata: [],
      providerDataLoading: false,
      selectedProvider: null,
      selectedProoviderName: null,
      action: null,
      record: null,
    };
  }
  componentDidMount() {
    this.updateProviderList();
  }
  updateProviderList = () => {
    const { history, serviceProviderApi } = this.props;
    this.setState({ providerDataLoading: true });

    const errorCallback = (error) => {
      this.setState({ providerDataLoading: false });
      message.error("Error Fetching Provider List");
    };

    const successCallback = (data) => {
      const providerData = convertServiceProviderListToDropdown(data);
      this.setState({ providerData, providerDataLoading: false });
    };
    try {
      serviceProviderApi.getServiceprovider(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  onProviderSelect = (id, value) => {
    if (value) {
      this.setState({
        selectedProvider: id,
        selectedProviderName: value.children,
      });
    } else {
      this.setState({ selectedProviderName: null, selectedProvider: null });
    }
  };
  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };
  onSubmit = ({ redirect = true } = {}) => {
    redirect && this.setState({ action: null, record: null });
  };
  render() {
    const {
      providerData,
      providerDataLoading,
      selectedProvider,
      selectedProviderName,
    } = this.state;
    return (
      <MainPage>
        <ListDeviceMangement
          providerData={providerData}
          providerDataLoading={providerDataLoading}
          selectedProvider={selectedProvider}
          onProviderSelect={this.onProviderSelect}
          onActionClick={this.onActionClick}
          onParentActionClick={this.props.onActionClick}
          selectedProviderName={selectedProviderName}
          parentBread={this.header}
        />
      </MainPage>
    );
  }
}
DeviceManagement.propTypes = {
  serviceProviderApi: PropTypes.object,
  providerData: PropTypes.array,
  providerDataLoading: PropTypes.bool,
  selectedProvider: PropTypes.string,
  deviceModelRecord: PropTypes.object,
  onProviderSelect: PropTypes.func,
  selectedProoviderName: PropTypes.string,
  onActionClick: PropTypes.func,
  parentBread: PropTypes.array,
};
const mapStateToProps = (state) => ({
  serviceProviderApi: state.apis.serviceProviderApi,
});
const connectedDeviceManagement = connect(mapStateToProps)(DeviceManagement);
export default withRouter(connectedDeviceManagement);
